import React, { useState, useEffect } from "react";
import DashboardAnswer from "../../../Components/layouts/Message/DashboardAnswer";
import AddnewsupportTicket from "../../../Components/layouts/SupportTicket/AddnewsupportTicket";
import SupportTicketanswer from "../../../Components/layouts/SupportTicket/SupportTicketanswer";
import SupportTicketTable from "../../../Components/layouts/SupportTicket/SupportTicketTable";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";
import { Modal } from "../../../Components/share/modal/Modal";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";

const SupportTicket = () => {
    const [newTicket, setNewTicket] = useState(false);
    const [TicketAnswer, setTicketAnswer] = useState(false);
    const [tickets, setTickets] = useState();
    const [answerId, setAnswerId] = useState();
    const [modalData, setModalData] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getTicket = useFetch({
        method: "GET",
        url: `TicketService/tickets`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setTickets,
    });

    useEffect(() => {
        getTicket.reFetch();
    }, [pagination]);
    useEffect(() => {
        tickets?.results.map(
            (ticket) => ticket.id == answerId && setModalData(ticket.subject)
        );
    }, [answerId]);

    return (
        <div className="SupportTicket">
            <div className=" flex SupportTicket__header justify-between items-center px-24 pt-24">
                <h3>تیکت‌های پشتیبانی</h3>
                <BtnPrimary
                    text="تیکت پشتیبانی جدید"
                    className=" px-12 py-8 mt-6 mb-8"
                    onClick={() => setNewTicket(!newTicket)}
                />
            </div>
            <SupportTicketTable
                setTicketAnswer={setTicketAnswer}
                TicketAnswer={TicketAnswer}
                tickets={tickets}
                setAnswerId={setAnswerId}
            />
            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={tickets?.results}
                pageSize={tickets?.page_count}
                className=" mt-[3rem]"
            />
            {TicketAnswer && (
                <Modal show={TicketAnswer}>
                    <DashboardAnswer
                        setTicketAnswer={setTicketAnswer}
                        setNewTicket={setNewTicket}
                        id={answerId}
                        subject={modalData}
                    />
                </Modal>
            )}
            {newTicket && (
                <Modal show={newTicket}>
                    <AddnewsupportTicket
                        close={setNewTicket}
                        data={modalData}
                        getTicket={getTicket}
                    />
                </Modal>
            )}
        </div>
    );
};

export default SupportTicket;
